import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiChangeType } from '../../../../../../../ai';
import { MultipleChoiceAddQuestionStrategy } from './multiple-choice-add.strategy';
import { MultipleChoiceDeleteQuestionStrategy } from './multiple-choice-delete.strategy';
import { MultipleChoiceUpdateQuestionStrategy } from './multiple-choice-update.strategy';
export var MultipleChoiceAiChangeStrategyFactory = /*#__PURE__*/function () {
  function MultipleChoiceAiChangeStrategyFactory() {
    _classCallCheck(this, MultipleChoiceAiChangeStrategyFactory);
  }

  _createClass(MultipleChoiceAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new MultipleChoiceAddQuestionStrategy(context);

        case AiChangeType.Update:
          return new MultipleChoiceUpdateQuestionStrategy(context);

        case AiChangeType.Delete:
          return new MultipleChoiceDeleteQuestionStrategy(context);

        default:
          throw new Error('Unsupported change type for multiple choice');
      }
    }
  }]);

  return MultipleChoiceAiChangeStrategyFactory;
}();